// Capacités PWA par rôle (matrice Phase 5)
export const canUsePWA = (role) => !!role && role !== "admin_technique";
export const canUseBiometric = (role) => !!role && role !== "admin_technique";

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
